import "./ExcelImportControls.css";

export default function ExcelImportControls({
  autoCreateFields,
  onAutoCreateFieldsChange,
  existingDossierMode,
  onExistingDossierModeChange,
  disabled,
  onImport,
}) {
  return (
    <section className="excel-import-controls">
      <div className="excel-import-controls__header">
        <h3>Import instellingen</h3>
        <p>
          Kies hoe POWER ontbrekende velden en bestaande dossiers behandelt.
        </p>
      </div>

      <div className="excel-import-controls__grid">
        <label className="excel-import-controls__toggle">
          <input
            type="checkbox"
            checked={autoCreateFields}
            onChange={(event) => onAutoCreateFieldsChange(event.target.checked)}
            disabled={disabled}
          />

          <div>
            <strong>Nieuwe velden automatisch aanmaken</strong>
            <span>
              POWER maakt ontbrekende FieldConfigs aan tijdens import.
            </span>
          </div>
        </label>

        <div className="excel-import-controls__mode">
          <label>Bestaande dossiers</label>

          <select
            value={existingDossierMode}
            onChange={(event) =>
              onExistingDossierModeChange(event.target.value)
            }
            disabled={disabled}
          >
            <option value="update">Bestaande dossiers bijwerken</option>
            <option value="create_new">Altijd nieuw dossier maken</option>
          </select>
        </div>
      </div>

      <button
        type="button"
        className="excel-import-controls__button"
        disabled={disabled}
        onClick={onImport}
      >
        Import starten
      </button>

      {disabled && (
        <p className="excel-import-controls__disabled">
          Import is geblokkeerd zolang er fouten zijn of een import loopt.
        </p>
      )}
    </section>
  );
}
